SubjectShortcuts = new (function () {
  this.setSelects = () => {
    let wrapper = $(".manage-subject-shortcuts");

    $("#subject-shortcuts-subject-filter", wrapper).select2({
      placeholder: "- Filter by subject -",
    });

    $("#subject-shortcuts-shortcut-filter", wrapper).select2({
      placeholder: "- Filter by shortcut -",
    });

    $("#subject-shortcuts-cycle-type-filter", wrapper).select2({
      placeholder: "- Filter by cycle type -",
      minimumResultsForSearch: Infinity,
    });
    const formWrapper = $(".subject_shortcuts-form");
    $("#subject_shortcut_cycle_type", formWrapper).select2({
      placeholder: "- Select -",
      width: "calc(100% - 34px)",
    });
  };
})();
